//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "integralhistory"
}



// WEBPACK FOOTER //
// ./src/components/integralhistory/integralhistory.vue